import { LegacyChecklistRecord } from '@/ui/pages/inspection/LegacyChecklistRecord';
import { AssetsPhotoStubActionable, processPhoto } from '@/services/assets-api/AssetsPhotoService';
import { isArray, isObject } from 'lodash';
import { photoRmFilterFn } from '@/services/assets-api/assets-helper';
import * as issueAssetsPhotos from '@/services/assets-api/issueAssetsPhotos';
import { ResponsesTypes } from '@/entities/checklist';

type AssetsPhotoStubActionableArray = Array<AssetsPhotoStubActionable | Record<string, unknown>>;

interface FormItem {
  response: AssetsPhotoStubActionable | Record<string, unknown> | AssetsPhotoStubActionableArray;
  photos: AssetsPhotoStubActionableArray;
  items: Array<FormItem>;
  response_type: string;
}

const processMultiplePhotoResponse = async (photos: Array<AssetsPhotoStubActionable>) => {
  const processedPhotos = await Promise.all(
    (photos as Array<AssetsPhotoStubActionable>).map(processPhoto),
  );

  return processedPhotos
    .filter(photo => photo && !photoRmFilterFn(photo)) as Array<AssetsPhotoStubActionable>;
};

async function processPhotosPerItem(item: FormItem) {
  if (item.response && isObject(item.response) && item.response_type !== ResponsesTypes.file) {
    const processedPhoto = await processPhoto(item.response as AssetsPhotoStubActionable);
    item.response = processedPhoto || {};
  }

  if (
    item.response
    && isArray(item.response)
    && item.response.length > 0
    && item.response_type !== ResponsesTypes.file
  ) {
    const processedPhotos = await processMultiplePhotoResponse(item.response as Array<AssetsPhotoStubActionable>);
    item.response = processedPhotos;
  }

  if (item.photos && item.photos.length > 0) {
    const processedPhotos = await processMultiplePhotoResponse(item.photos as Array<AssetsPhotoStubActionable>);
    item.photos = processedPhotos;
  }

  if (item.items && item.items.length > 0) {
    const promises = item.items.map(processPhotosPerItem);
    await Promise.all(promises);
  }
}

export const processPhotos = async (inspectionRecord: LegacyChecklistRecord): Promise<LegacyChecklistRecord> => {
  await processPhotosPerItem(inspectionRecord.form as unknown as FormItem);

  const issueActions = inspectionRecord.issues;
  if (!issueActions) {
    return inspectionRecord;
  }

  await Promise.all(
    Object.values(issueActions)
      .filter(issueAction => issueAction.action && issueAction.action === 'issue')
      .map(issueAction => issueAssetsPhotos.processPhotos(issueAction.params)),
  );

  return inspectionRecord;
};

// functions below left to document other implementation possibilities

// async function processFormItemsParamsPhotosFullBulk(item: FormItem) {
//   /**
//    * collect photos from the whole structure,
//    * and set temporary ids for uploading fileName to image_id_upload and drawing_id_upload
//    * bulk upload in chunks all of them, have a list of new ids and fileNames back
//    * map ids back into structure by doing a second iteration
//    * mapping by fileName to image_id_upload and drawing_id_upload
//    * and setting image_id and drawing_id to new ids and unsetting image_id_upload and drawing_id_upload
//    */
// }

// async function processFormItemsParamsPhotos(item: FormItem) {
//   if ((item.response && item.response.image) || (item.photos && item.photos.length > 0)) {
//     console.log(item);
//
//     /**
//      * go through item photos/response and grab all images + drawings - imagesToUpload
//      * make bulk uploads in chunks by 20, merge all uploaded records with imageIds - uploadedImages
//      * iterate uploadedImages and put ids from it to item photos/response, fill image_id or drawing_id
//      * go to the next item
//      */
//   }
//
//   if (item.items && item.items.length > 0) {
//     // eslint-disable-next-line guard-for-in,no-restricted-syntax
//     for (const j in item.items) {
//       // eslint-disable-next-line no-await-in-loop
//       await processFormItemsParamsPhotos(item.items[j]);
//     }
//   }
// }
